import { render, staticRenderFns } from "./router-build.vue?vue&type=template&id=459df5cc"
import script from "./router-build.vue?vue&type=script&lang=js"
export * from "./router-build.vue?vue&type=script&lang=js"
import style0 from "./router-build.vue?vue&type=style&index=0&id=459df5cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports